export class Echevinat {
     description:string;
     utilisable:boolean = true;
     profilUtilisationId:number =  0;
     profilVisualisationId:number = 0;
     tri: string;
     id: number;
     constructor(data:any) {
         Object.assign(this, data);
     }
 
}
 